export default function NotificationsSettings() {
  return <div>Notifications</div>;
} 